import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export interface NewsArticle {
  id: number;
  title: string;
  url: string;
  news_site: string;
}

const useQuerySpaceflightNews = () => {
  return useQuery<NewsArticle[]>({
    queryKey: ['spaceflight-news'],
    queryFn: async () => {
      const { data } = await axios.get(
        'https://api.spaceflightnewsapi.net/v4/articles/?limit=3',
        { withCredentials: false }
      );
      return data.results;
    },
    staleTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
  });
};

export default useQuerySpaceflightNews;
